import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 528FF16A-C55C-43F9-8E0B-3879A209AEDE
 * name polymer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/polymer.svg
 * tags
 * - Brand / Logo 
 * - Developer / Languages 
 */
export const PolymerIcon = createSvgIcon(<><path d="M19,4H15L7.1,16.63L4.5,12L9,4H5L0.5,12L5,20H9L16.89,7.37L19.5,12L15,20H19L23.5,12L19,4Z" /></>, 'PolymerIcon');
export default PolymerIcon